import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 10,
    color: "#fff",
  },
}));

const Loading = ({ showBackdrop, boost = false }) => {
  const classes = useStyles();
  const boostStyle = boost && { borderLeftColor: "#4B2BA3" };

  return (
    <div className="top-0 left-0 h-screen w-screen fixed flex justify-center items-center z-50">
      {showBackdrop && (
        <Backdrop className={classes.backdrop} open={showBackdrop} />
      )}
      <div
        className="loader items-center justify-center"
        style={{ height: "80px", width: "80px", ...boostStyle }}
      />
    </div>
  );
};

export default Loading;
